import { useSyncExternalStore } from "react";
import { getState, subscribe } from "./store";

/** Subscribe a component to the whole workspace state. */
export function useStore() {
  return useSyncExternalStore(subscribe, getState, getState);
}
